import { Link } from 'react-router-dom';

import callouts from '../../data/services';

export default function Services() {
  return (
    <div dir="rtl" className="bg-gray-100">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-2xl  sm:py-24 lg:max-w-none lg:py-32">
          <h2
            id="product"
            className="text-2xl font-bold text-main font-custom1">
            دوره ها و محصولات
          </h2>

          <div className="mt-6 space-y-12 lg:grid lg:grid-cols-3 lg:gap-x-6 lg:space-y-0">
            {callouts.map((callout) => (
              <div key={callout.name} className="group relative">
                <div className="relative h-80 w-full overflow-hidden rounded-lg bg-white group-hover:opacity-75 sm:aspect-w-2 sm:aspect-h-1 sm:h-64 lg:aspect-w-1 lg:aspect-h-1">
                  <img
                    src={callout.imageSrc}
                    alt={callout.name}
                    className="h-auto w-auto object-contain"
                  />
                </div>
                <h3 className="mt-6 text-sm text-gray-500 font-bold">
                  <Link
                    to={callout.href ? callout.href : `/service/${callout.id}`}
                    state={{ data: callout }}>
                    <span className="absolute inset-0 font-bold" />
                    {callout.name}
                  </Link>
                </h3>
                <p className="text-base font-semibold text-gray-900 font-bold">
                  {callout.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
